module.exports = __webpack_public_path__ + "img/05-pic.68db44dd.png";